import { Injectable } from "@angular/core";
import { UseCase } from "../../shared/use-case";
import { UpdateShoppingCartUseCaseResponse } from "./update-shopping-cart-usecase-response";
import { UpdateShoppingCartUseCaseRequest } from "./update-shopping-cart-status-usecase-request";
import { LogService } from "../../shared/log.service";
import { TranslationConfig } from "../../translation/translation-config";
import {HttpClient} from '@angular/common/http';
import { ValidationError } from "../../shared/validation.error";
import {Subject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UpdateShoppingCartUseCase extends UseCase<UpdateShoppingCartUseCaseRequest, UpdateShoppingCartUseCaseResponse> {

    constructor(
        _logService: LogService,
        _httpClient: HttpClient,
        _translationConfig: TranslationConfig
    ) {
        super(_logService, _httpClient, _translationConfig.enableUseCaseStatusLogs);
    }

    protected override validate(request: UpdateShoppingCartUseCaseRequest) {
        if (!request.totalPrice){
            new ValidationError("There is no totalPrice<Subject> to subscribe!");
        }
        if (!request.totalQuantity){
            new ValidationError("There is no totalQuantity<Subject> to subscribe!");
        }
      
    }

    protected override executeBusinessLogic(request: UpdateShoppingCartUseCaseRequest): UpdateShoppingCartUseCaseResponse {
        
        let response:UpdateShoppingCartUseCaseResponse = {};
        const totalPrice = request.totalPrice as Subject<number>;
        const totalQuantity = request.totalQuantity as Subject<number>;
        totalPrice.subscribe((totalPrice)=> {
            response = {totalPrice:totalPrice};
            return response;
        });
        totalQuantity.subscribe((totalQuantity) => {
            response = {totalQuantity:totalQuantity};
            return response;
        });
        this._logService.info('Response : '+response.totalPrice);
        return response;
    }

}